module.exports = __webpack_public_path__ + "static/media/girl-img.12c7c994.svg";